import { freddyTheme } from '@coolblue-development/freddy';
export const getAlternativeProductCardStyles = ({ orientation, fullWidth, }) => {
    return {
        ...(orientation === 'vertical' && {
            height: '100%',
            width: fullWidth ? 'unset' : '280px',
        }),
        ...(orientation === 'horizontal' && {
            display: 'flex',
            height: 'initial',
            width: fullWidth ? 'unset' : '360px',
            '& label': {
                display: 'flex',
            },
        }),
        label: { height: '100%' },
    };
};
export const getAlternativeProductImageStyles = ({ orientation, }) => {
    return {
        minWidth: orientation === 'vertical' ? 'initial' : '10rem',
        margin: orientation === 'vertical'
            ? `0 0 ${freddyTheme.spacing[200]} 0`
            : `0 ${freddyTheme.spacing[200]} 0 0`,
        ...(orientation === 'horizontal' && {
            flex: '0 0 25%',
        }),
    };
};
//# sourceMappingURL=AlternativeProductCard.styles.js.map